import { createContext, type PropsWithChildren, useContext } from 'react';
import { type NavV2Response } from '@cx-web/api-clients/nav-api/types';

// Route-$ page chrome: the header/bottom-nav data. Scoped to the route-$ shell because
// product-plus renders its own bespoke header/footer and never consumes it. Provider is
// mounted once in StandardLayout; the deep MobileBottomNav tree reads it via context.
const NavDataContext = createContext<NavV2Response | undefined>(undefined);
NavDataContext.displayName = 'NavDataContext';

export const NavDataProvider = ({ children, navData }: PropsWithChildren<{ navData: NavV2Response }>) => {
  return <NavDataContext.Provider value={navData}>{children}</NavDataContext.Provider>;
};

export function useNavData(): NavV2Response {
  const ctx = useContext(NavDataContext);
  if (ctx === undefined) {
    throw new Error('useNavData must be used within NavDataProvider');
  }
  return ctx;
}
